import { supabase } from '../lib/supabase';
import { AuthService } from './authService';

export interface AdminUser {
  id: string;
  username: string;
  email?: string;
  isAdmin?: boolean;
  clientId?: string | null;
  client?: { id: string; name: string; slug: string } | null;
  created_at: string;
  last_login?: string;
}

function getAuthToken(): string {
  const session = AuthService.getSession();
  if (!session || !session.token) {
    throw new Error('No active session');
  }
  return session.token;
}

export const AdminUserService = {
  async list(): Promise<AdminUser[]> {
    const token = getAuthToken();
    const { data, error } = await supabase.functions.invoke('admin-users-manage', {
      headers: {
        'x-admin-session': token,
        'x-operation': 'list',
      },
    });

    if (error) throw error;
    return (data?.users ?? []).map((row: any) => ({
      id: row.id,
      username: row.username,
      email: row.email,
      isAdmin: row.is_admin ?? false,
      clientId: row.client_id ?? null,
      client: row.client ?? null,
      created_at: row.created_at,
      last_login: row.last_login,
    }));
  },

  async create(identifier: string, password: string, isAdmin: boolean, clientId?: string | null): Promise<void> {
    const token = getAuthToken();
    const { error } = await supabase.functions.invoke('admin-users-manage', {
      method: 'POST',
      headers: {
        'x-admin-session': token,
        'x-operation': 'create',
      },
      body: {
        identifier,
        password,
        isAdmin,
        clientId,
      },
    });
    if (error) throw error;
  },

  async update(id: string, updates: { isAdmin?: boolean; clientId?: string | null }): Promise<void> {
    const token = getAuthToken();
    const { error } = await supabase.functions.invoke('admin-users-manage', {
      method: 'PATCH',
      headers: {
        'x-admin-session': token,
        'x-operation': 'update',
      },
      body: {
        id,
        ...updates,
      },
    });
    if (error) throw error;
  },

  async delete(id: string): Promise<void> {
    const token = getAuthToken();
    const { error } = await supabase.functions.invoke('admin-users-manage', {
      method: 'DELETE',
      headers: {
        'x-admin-session': token,
        'x-operation': 'delete',
      },
      body: { id },
    });
    if (error) throw error;
  },
};

export default AdminUserService;
